import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class TopAgentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/TopAgent/TopAgentBrowser")
	}

	render() {
		return (
			<Activity 
				name="TopAgent"
				RenderedComponent={this.RenderedComponent}
				context="TopAgent"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(TopAgentActivity)
